import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-candidate-patient-name',
    templateUrl: './candidate-patient-name.component.html',
    styleUrls: ['./candidate-patient-name.component.scss'],
    imports: [DatePipe]
})
export class CandidatePatientNameComponent {
  @Input() candidate: { patientFullName: string; patientDob: Date };

  constructor() {}
}
